import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import { red } from "@material-ui/core/colors"
import Button from "@material-ui/core/Button"
import { navigate } from "gatsby"
import sales from "../../images/site/temp/sales.png"
const useStyles = makeStyles(theme => ({
  root: {
      width:'100%',
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
}))
const handleClick = _ => navigate("/contacto/")

export default function Buscamos() {
  const classes = useStyles()
  return (
    <Card className={classes.root}>
      <CardMedia className={classes.media} title="Paella dish">
        <img alt="" src={sales} style={{width:"100%"}}/>
      </CardMedia>
      <CardContent style={{ paddingBottom: 0 }}>
        <div>Buscamos distribuidores</div>
        <div>Buscamos comisionistas</div>
      </CardContent>
      <CardActions>
        <Button size="small" style={{ paddingLeft: 8 }} onClick={handleClick}>
          Acercanos tu curriculum
        </Button>
      </CardActions>
    </Card>
  )
}
